import { render, staticRenderFns } from "./ListCustomerPage.vue?vue&type=template&id=51c5b8a0"
import script from "./ListCustomerPage.vue?vue&type=script&lang=js"
export * from "./ListCustomerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports